import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

interface ProductSearchFieldProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

export const ProductSearchField = ({ searchQuery, setSearchQuery }: ProductSearchFieldProps) => {
  return (
    <div className="space-y-2">
      <label className="text-sm font-medium leading-none">
        Rechercher un produit
      </label>
      <div className="relative">
        <Input
          type="text"
          placeholder="Rechercher un produit..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="pl-8"
        />
        <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
      </div>
    </div>
  );
};